module.exports = __webpack_public_path__ + "images/emoji/crocodile.bbb2c8e6546285428641.png";